import * as yup from "yup";

export const HarvestcreateSchema = yup.object().shape({
  harvestDate: yup.string().required("Required"),
  selectCrop: yup.string().required("Required"),
  harvestQuantity: yup.string().required("Required"),
  packagingType: yup.string().required("Required"),
  sellingPricePerKg: yup.string().required("Required"),
  uploadProductPhoto: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  transportation: yup.string(),
});
